import React, { FC, useState } from 'react'
import { YHModal } from '@/components/YHModal'
import { usePurchaseDrDetailsModel } from './purchaseDrDetailsModel'
import { YhBox } from '@/components/YhBox'
import { Table, Select, message } from 'antd'
import { ColumnsType } from 'antd/lib/table'

import useGlobalModel, { transOptions } from '@/model/globalModel'
import { ISelectOptions } from '@/types/ScmTypes'
import { warehouseService } from '@/views/base/warehouse/warehouseService'
import { IVRMshelfDetail } from '@/views/base/warehouse/warehouseTypes'
import { ISCMPDrGoodsDetail } from '../../purchaseDrTypes'
type IBatchSelectWarehouseModal = {
    mode: 'add' | 'edit' | 'look'
    batchSelectWarehouseModal: boolean
    setBatchSelectWarehouseModal: any
    batchSelectWarehouseList: ISCMPDrGoodsDetail[]
    selectedRowKeys: string[]
}

export const BatchSelectWarehouseModal: FC<IBatchSelectWarehouseModal> = (props) => {
    const { mode, batchSelectWarehouseModal, setBatchSelectWarehouseModal, batchSelectWarehouseList, selectedRowKeys } = props
    const { editGoodsList, setEditGoodsList, addGoodsList, setAddGoodsList } = usePurchaseDrDetailsModel()

    const {
        warehouseList,
        shopAndOrg: { shopId },
    } = useGlobalModel(({ warehouseList, shopAndOrg }) => [warehouseList, shopAndOrg])

    const [shelfInfo, setShelfInfo] = useState<IVRMshelfDetail | null>(null) //记录选中的货位信息

    const onCancel = () => {
        setBatchSelectWarehouseModal(false)
        setShelfInfo(null)
    }

    //货位列表 Api
    const shelfLoadData = async (whObj: ISelectOptions) => {
        const searchParams = {
            shopId,
            warehouseId: whObj.id,
            warehouseCode: whObj.value,
            code: '临时货位',
            pageSize: 10,
            pageNum: 1,
        }
        let { retData: records } = await warehouseService.shelfAllPage(searchParams)
        if (!records || !records.length) {
            message.warning('该仓库下没有临时货位，请联系后台人员添加')
            setShelfInfo(null)
            return
        }
        setShelfInfo(records[0])
    }

    const onSubmit = () => {
        if (!shelfInfo) {
            message.warning('请选择仓库或者该仓库没有临时货位')
            return
        }
        let dataSource = mode === 'edit' ? [...editGoodsList] : [...addGoodsList]
        let codeList = batchSelectWarehouseList.map((item) => item.id)
        dataSource = dataSource.map((item) => {
            return codeList.includes(item.id)
                ? {
                    ...item,
                    inShelfId: shelfInfo.id,
                    inShelfCode: shelfInfo.code,
                    inWarehouseName: shelfInfo.warehouseName,
                    inWarehouseCode: shelfInfo.warehouseCode,
                }
                : item
        })
        mode === 'edit' ? setEditGoodsList(dataSource) : setAddGoodsList(dataSource)
        onCancel()
    }

    const columns: ColumnsType<ISCMPDrGoodsDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            align: 'center',
            render: (t: any, r: any, i: number) => i + 1,
        },
        {
            title: '商品编号',
            align: 'center',
            dataIndex: 'materialCode',
        },
        {
            title: '商品名称',
            align: 'center',
            dataIndex: 'materialName',
        },
    ]

    const rightChildren = (
        <div >
            <span className="label-name">仓库：</span>
            <Select
                style={{ width: 260 }}
                options={transOptions(warehouseList)} //过滤掉直发库
                placeholder="请选择仓库"
                onChange={(value: string, option) => {
                    value && shelfLoadData(option as ISelectOptions)
                }}
            />
        </div>
    )

    return (
        <YHModal visible={batchSelectWarehouseModal} onOk={onSubmit} onCancel={onCancel} title="批量选择仓库" width={'60%'} bodyHeight={500} showFooter={true}>
            <YhBox title={rightChildren} style={{ marginBottom: '15px' }}>
                <Table
                    bordered columns={columns} dataSource={batchSelectWarehouseList} pagination={false} scroll={{ x: 'max-content', y: 400 }} />
            </YhBox>
        </YHModal>
    )
}
